<template>
  <div>
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <!-- <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
          <span v-if="item.redirect==='noRedirect'||index==levelList.length-1 && (typeof item.meta.title === 'function')" class="no-redirect">{{ item.meta.title($route.query) }}</span>
          <a v-else @click.prevent="handleLink(item)" :class="item.path == '/channelManagement'?'channelClass':''">{{ item.meta.title }}</a>
        </el-breadcrumb-item> -->
         <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.url">
          <span v-if="index == levelList.length-1" class="no-redirect">{{ item.name }}</span>
          <a v-else @click.prevent="handleLink(item)">{{ item.name }}</a>
        </el-breadcrumb-item>
      </transition-group>
      <div class="title">{{titleName(lastTitle)}}</div>
    </el-breadcrumb>
  </div>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null,
      lastTitle: '',
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      console.log(matched, 'matched');

      // if (!this.isDashboard(first)) {
      //   matched = [{ path: '/homePage', meta: { title: '首页' } }].concat(matched)
      // }

      // this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      let levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      this.lastTitle = levelList.slice(-1)[0].meta.title;

      this.levelList = levelList.slice(-1)[0].meta.breadcrumbList;

      if (!this.isDashboard(first) && !this.levelList.some(item => item.name == '首页')) {
        this.levelList.unshift({
          url: '/',
          name: '首页'
        })
      }
      // console.log("最后一个",this.levelList.pop());
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'HomePage'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    titleName(val){
      let defaultName = val;
      let nameList = {
        "快递查价": "快递/专线渠道查价",
      };
      return nameList[val] || defaultName;

    },
    handleLink(item) {
      // 渠道页禁止点击
      // if (item.path == '/channelManagement') return
      // console.log(item);
      // // 空运订单详情跳转空运订单列表
      // if (item.path == '/orderManagement/airDetail') return
      // if (this.$route.path == '/orderManagement/airDetail') {
      //   this.$router.push({ path: '/orderManagement/air' })
      //   return
      // }
      // // 询盘订单详情跳转询盘列表
      // if (item.path == '/orderManagement/inquiryDetail') return
      // if (this.$route.path == '/orderManagement/inquiryDetail') {
      //   this.$router.push({ path: '/orderManagement/inquiry' })
      //   return
      // }
      // //立即报价跳转询盘列表
      // if (item.path == '/orderManagement/offerNow') return
      // if (this.$route.path == '/orderManagement/offerNow') {
      //   this.$router.push({ path: '/orderManagement/inquiry' })
      //   return
      // }
      // //报价详情跳转询盘列表
      // if (item.path == '/orderManagement/offerDetail') return
      // if (this.$route.path == '/orderManagement/offerDetail') {
      //   this.$router.push({ path: '/orderManagement/inquiry' })
      //   return
      // }
      // const { redirect, path } = item
      // if (redirect) {
      //   this.$router.push(redirect)
      //   return
      // }
      this.$router.push(this.pathCompile(item.url))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  background-color: rgba(255, 255, 255, 1);
  height: 104px;
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  padding-left: 24px;
  display: flex;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
  .title {
    font-size: 20px;
    font-weight: 550;
    position: absolute;
    top: 95px;
  }
}
.channelClass {
  &:hover {
    color: #303133;
    cursor: default;
  }
}
</style>
